import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SourceCodeIcon = () => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32">
    {/* Left section */}
    <path
      d="M19.68 25.52C19.68 25.87 19.48 26.2 19.15 26.38L16.55 27.79C16.24 27.96 15.87 27.97 15.55 27.81C13.38 26.7 7.33 23.36 5.52 22.36C5.19 22.19 5 21.86 5 21.51V10.8C5 10.45 5.2 10.12 5.53 9.94L8.13 8.52C8.46 8.35 8.86 8.35 9.19 8.52L12.34 10.23L16 12.21L19.13 13.91C19.46 14.09 19.67 14.42 19.67 14.77V25.52H19.68Z"
      fill="#17E88F"
    />

    {/* Right section */}
    <path
      d="M26.47 9.93L19.66 6.26L17.6 5.14C16.89 4.75 16 5.23 16 6V15.6C16 15.96 16.2 16.29 16.53 16.47L23.33 20.15L25.4 21.27C26.11 21.65 27 21.17 27 20.41V10.8C27 10.44 26.8 10.11 26.47 9.93Z"
      fill="#17E88F"
    />

    {/* Center overlapping section */}
    <path
      d="M22.81 11.91L16 8.24L13.94 7.12C13.23 6.73 12.34 7.21 12.34 7.98V17.58C12.34 17.94 12.54 18.27 12.87 18.45L19.67 22.13L21.74 23.25C22.45 23.63 23.34 23.15 23.34 22.39V12.78C23.34 12.42 23.14 12.09 22.81 11.91Z"
      fill="#0FB870"
    />

    {/* Darker accents */}
    <path
      d="M19.67 18.16V22.13L12.87 18.45C12.54 18.27 12.34 17.94 12.34 17.59V10.23L16 12.22L19.13 13.92C19.46 14.1 19.66 14.43 19.66 14.78V18.17H19.67V18.16Z"
      fill="#0D9359"
    />
    <path
      d="M23.34 12.78V20.15H23.33L16.53 16.47C16.2 16.29 16 15.96 16 15.6V8.23L22.81 11.91C23.14 12.09 23.34 12.42 23.34 12.78Z"
      fill="#0D9359"
    />
  </SvgIcon>
);

export default SourceCodeIcon;
